// @flow
import env from '../../../environment';
import {postCreator, getCreator} from '../../../http';

export const endpoints = Object.freeze({
  SAVE_SOCIAL: `${env.baseApiUrl}/ui/admin/store/social-media`,

  SAVE_TIKTOK_INTEGRATION: `${env.baseApiUrl}/ui/admin/store/tiktok-integration`,
  GET_TIKTOK_INTEGRATION: `${env.baseApiUrl}/ui/admin/store/tiktok-integration`,
});

export type SaveSocialMediaRequest = {
  socialMediaTypeId: string,
  identifier: string,
};

export const saveSocialMediasApi = postCreator(endpoints.SAVE_SOCIAL);

export type SaveTikTokIntegrationRequest = {
  pixelId: string,
};

export const saveTikTokIntegrationApi = postCreator(
  endpoints.SAVE_TIKTOK_INTEGRATION
);

export const getTikTokIntegrationApi = getCreator(
  endpoints.GET_TIKTOK_INTEGRATION
);
